import React from "react";
import AdminHeader from "../components/Layout/AdminHeader";
import AdminSideBar from "../components/Admin/Layout/AdminSideBar";
import AllUsers from "../components/Admin/AllUsers";

const AdminDashboardUsers = () => {
  return (
    <div className="admin-dashboard-container">
      <AdminHeader />
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-wrapper">
          <div className="admin-dashboard-sidebar">
            <AdminSideBar active={4} />
          </div>
          <div className="admin-dashboard-main admin-page-shell">
            <header className="admin-page-hero">
              <div>
                <p className="admin-page-eyebrow">Super Admin People</p>
                <h1>All Users</h1>
                <p className="admin-page-copy">Review user growth, account details, profile access, and moderation actions.</p>
              </div>
            </header>
            <AllUsers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardUsers;
